import { DATA_ROOM_FOLDER_FILES_ROUTE } from '@src/app/shared/utils/data-room-document-link.util';

/** Onde as declarações dos sócios ficam no Data Room (texto do link, igual ao protótipo). */
export const PARTNER_INCOME_TAX_SOURCE_PATH = 'Data Room › Societário › Sócios PF › IRPF';

/** Raiz do Data Room de uma empresa (lista de pastas). */
export const DATA_ROOM_COMPANY_FOLDERS_ROUTE = '/dashboard/market/data-room/company-folders';

/** Parametrização, onde fica a política de garantias (linha "IR dos sócios: pontos de atenção e garantias"). */
export const PARAMETRIZATION_ROUTE = '/dashboard/management/back-office/support/parametrizacao';

/** Link para a pasta das declarações: a IRPF, a Sócios PF (pai) ou a raiz do Data Room da empresa. */
export interface PartnerIncomeTaxFolderLink {
  route: string[];
  queryParams: Record<string, string> | null;
  /** Texto do link na linha de contexto. */
  label: string;
  /** Rótulo do botão do estado vazio. */
  buttonLabel: string;
  /** Rótulo curto do link no bloco "Declarações no Data Room". */
  irpfLinkLabel: string;
}

/**
 * Escolhe a pasta mais funda que existe: IRPF, depois Sócios PF, depois a raiz do Data Room da empresa (pasta ainda
 * não criada). O backend manda os ids no `overview` (`irpfFolderId`, `partnerFolderId`).
 */
export function buildFolderLink(
  companyId: string,
  irpfFolderId: string | null | undefined,
  partnerFolderId: string | null | undefined
): PartnerIncomeTaxFolderLink {
  if (irpfFolderId) {
    return {
      route: [DATA_ROOM_FOLDER_FILES_ROUTE, irpfFolderId],
      queryParams: { companyId },
      label: PARTNER_INCOME_TAX_SOURCE_PATH,
      buttonLabel: 'Abrir a pasta IRPF no Data Room',
      irpfLinkLabel: 'Abrir a pasta IRPF',
    };
  }
  if (partnerFolderId) {
    return {
      route: [DATA_ROOM_FOLDER_FILES_ROUTE, partnerFolderId],
      queryParams: { companyId },
      label: 'Data Room › Societário › Sócios PF',
      buttonLabel: 'Abrir a pasta Sócios PF no Data Room',
      irpfLinkLabel: 'Abrir a pasta Sócios PF',
    };
  }
  return {
    route: [DATA_ROOM_COMPANY_FOLDERS_ROUTE, companyId],
    // Com a empresa na URL, como os links de pasta: no escopo "Todas as empresas" é dela que a tela tira a empresa.
    queryParams: { companyId },
    label: 'Abrir o Data Room da empresa',
    buttonLabel: 'Abrir o Data Room da empresa',
    irpfLinkLabel: 'Abrir o Data Room da empresa',
  };
}
